import { Flex, Heading, Typography } from "@sidelinesports/fan-design-system";
import type { ApiScoringEvent } from "../../../../../api/index.ts";
import { FormattedRelativeTime } from "../../../../../components/index.tsx";

export type ScoringEventItemProps = {
  scoringEvent: ApiScoringEvent & {
    points: {
      base: number;
      powerup: number;
      total: number;
    };
  };
};

export const ScoringEventItem = ({ scoringEvent }: ScoringEventItemProps) => {
  return (
    <Flex direction="row" gap={8} align="center" justify="between">
      <Flex direction="column" gap={4}>
        <Typography size="md">
          {scoringEvent.player.initialAndLastName}
          {" - "}
          {scoringEvent.gameEvent.description}
        </Typography>
        <Typography size="md" color="muted">
          <FormattedRelativeTime
            value={scoringEvent.createdAt}
            style="narrow"
          />
        </Typography>
      </Flex>
      <Heading level={3} as="div">
        {scoringEvent.points.total.toLocaleString()}
      </Heading>
    </Flex>
  );
};
